var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-half-section"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_vm._l((_vm.info.descriptions),function(description){return _c('p',{key:description,domProps:{"innerHTML":_vm._s(description)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }